export default __webpack_public_path__ + "static/media/simongame.98bfbb9d.png";